// extracted by mini-css-extract-plugin
module.exports = {"icon":"StyledIcon_icon__jQaDK"};